<template>
  <div style="margin-top: 30px;">
    <h1>Welcome to Experience Auto Group</h1>
    <p style="margin-bottom: 30px">
      Select a dealership below to begin your credit application.
    </p>
    <div>
      <div>
        <router-link to="/lead/pss/lcr">Porsche LCR</router-link>
      </div>
      <div>
        <router-link to="/lead/ffl/lcr">Fort Lauderdale LCR</router-link>
      </div>
      <div>
        <router-link to="/lead/fli/lcr">Long Island LCR</router-link>
      </div>
      <div>
        <router-link to="/lead/gcm/lcr">Gold Coast LCR</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Dashboard',
  props: {
  }
}
</script>

<style scoped lang="scss">
</style>
